import { ModifierProperty } from '@/enums';
import { useGetComponentConfigByModule } from '@/hooks';
import { DropdownItemConfigProps } from '@/types';
import { CustomDropdown, CustomDropdownProps } from '@amili-v3/amili-v3-design';
import { MenuItemType } from 'antd/es/menu/hooks/useItems';
import React, { memo, useMemo } from 'react';

const DropdownConfig: React.FC<CustomDropdownProps> = props => {
  const { menu, ...rest } = props;

  const componentConfig = useGetComponentConfigByModule('button');

  const items = useMemo(
    () =>
      menu?.items?.reduce((accumulator, menuItem) => {
        const customKey = !!menuItem?.key ? `${menuItem.key}-item` : '';
        const modifier = componentConfig[customKey]?.modifier;

        const disabled = modifier === ModifierProperty.DISABLED;
        const hidden = modifier === ModifierProperty.HIDDEN;

        if (hidden || !menuItem) return accumulator;

        accumulator.push({
          ...menuItem,
          'data-customization-key': customKey,
          disabled: disabled || (menuItem as MenuItemType)?.disabled,
        } as DropdownItemConfigProps);
        return accumulator;
      }, [] as DropdownItemConfigProps[]),
    [menu?.items, componentConfig],
  );

  return <CustomDropdown {...rest} menu={{ ...menu, items }} />;
};

export default memo(DropdownConfig);
